import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Layout, Spin, Result } from 'antd';
import { oauthService } from '../../services/api';
import AppHeader from '../../components/AppHeader/AppHeader';

const { Content } = Layout;

const CallbackPage = () => {
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const location = useLocation();
    // Используем useRef для отслеживания состояния обработки
    const isProcessingRef = useRef(false);

    useEffect(() => {
        const handleCallback = async () => {
            // Если обработка уже запущена, не запускаем её снова
            if (isProcessingRef.current) {
                return;
            }

            isProcessingRef.current = true;

            // Получаем параметры из URL
            const params = new URLSearchParams(location.search);
            const code = params.get('code');
            const state = params.get('state');
            const error = params.get('error');
            const errorDescription = params.get('error_description');

            if (error) {
                setError(`Ошибка авторизации: ${error}. ${errorDescription || ''}`);
                setLoading(false);
                isProcessingRef.current = false;
                return;
            }

            if (!code || !state) {
                setError('Отсутствуют необходимые параметры для авторизации');
                setLoading(false);
                isProcessingRef.current = false;
                return;
            }

            try {
                const result = await oauthService.handleCallback(code, state);

                if (result.success) {
                    navigate('/');
                } else {
                    setError(result.message || 'Произошла ошибка при обработке авторизации');
                    setLoading(false);
                }
            } catch (err) {
                console.error('Ошибка обработки callback:', err);
                setError('Произошла ошибка при обработке авторизации');
                setLoading(false);
            } finally {
                isProcessingRef.current = false;
            }
        };

        handleCallback();
    }, [location, navigate]);

    return (
        <Layout style={{ minHeight: '100vh' }}>
            <AppHeader />
            <Content style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '24px' }}>
                {loading ? (
                    <Spin size="large" tip="Выполняется вход в систему..." />
                ) : (
                    <Result
                        status="error"
                        title="Ошибка авторизации"
                        subTitle={error}
                        extra={[
                            <button
                                key="login"
                                className="ant-btn ant-btn-primary"
                                onClick={() => navigate('/login')}
                            >
                                Вернуться на страницу входа
                            </button>
                        ]}
                    />
                )}
            </Content>
        </Layout>
    );
};

export default CallbackPage;